import React from 'react';
import { useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';

import { MEDIA_URL } from '../../constants/api';
import EmptyAvatar from '../../assets/images/emptyAvatar.png';

const WidgetUsersOnline = () => {
  const { users: usersOnline } = useSelector((state) => state?.userOnlineList);
  const {
    user: {
      id: myId = null
    } = {}
  } = useSelector((state) => state?.getMyProfile);

  const usersUnic = usersOnline
    .filter((obj, index, self) => index === self.findIndex((t) => t.id === obj.id));

  return (
    <div className="flex flex-row ml-[1.5rem] gap-[4px]">
      {!!usersUnic.length && usersUnic?.map((user, index) => user?.id !== `${myId}` && (
        <React.Fragment key={user?.id}>
          <div
            className="cursor-pointer -ml-[1.5rem]"
            data-tip=""
            data-for={`${user?.id}`}
            style={{ zIndex: index + 1 }}
          >
            <img
              src={user?.info?.avatar ? `${MEDIA_URL}/${user?.info?.avatar}` : EmptyAvatar}
              alt="avatar"
              className="w-[2rem] h-[2rem] rounded-full border-[2px] border-success"
            />
          </div>
          <ReactTooltip
            id={`${user?.id}`}
            place="right"
            effect="solid"
            delayShow={500}
          >
            {user?.info?.name}
          </ReactTooltip>
        </React.Fragment>
      ))}

    </div>
  );
};

export default WidgetUsersOnline;
